import Handlebars from 'handlebars';

import CartQuantitySelector from '../../components/cart/cart-quantity-selector';
import Page from '../page';
import PageHelper from '../../helpers/page-helper';
import MessageHelper from '../../helpers/message-helper';

export default class NewReturnsCartPage extends Page {
  private openModalButton: JQuery;
  private handlebarsTemplate: JQuery;
  private returnReason: JQuery;
  private salesOrderText: JQuery;
  static updateEntrySelector = '.js-updateEntry';
  static modalTableSelector = '.js-modalTable';
  private entryInput: JQuery;
  private sidebarInput: JQuery;
  private sidebarOrderRecipientId: JQuery;
  private sidebarOrderNumber: JQuery;
  private placeOrderCartButton: JQuery;
  private updateCartButton: JQuery;
  private termsCheckboxes: JQuery;

  private submitForms: JQuery;
  private updateRowRequest?: JQuery.jqXHR;

  constructor(container: JQuery) {
    super();

    this.openModalButton = container.find('.js-openSearchModal');
    this.handlebarsTemplate = container.find('.js-handlebarsSearchModal');
    this.returnReason = container.find('.js-returnReason');
    this.salesOrderText = container.find('.js-salesOrderText');
    this.entryInput = container.find('.js-entryInput');
    this.sidebarInput = container.find('.js-sidebarInput');
    this.sidebarOrderNumber = container.find('.js-sidebarOrderNumber');
    this.sidebarOrderRecipientId = container.find('.js-sidebarOrderRecipientId');
    this.placeOrderCartButton = container.find('.js-placeOrderCartButton');
    this.updateCartButton = container.find('.js-updateCartButton');
    this.submitForms = container.find('.js-submitFormControl');
    this.termsCheckboxes = container.find('#acceptedDataPrivacyPolicies, #acceptedTermsAndConditions');

    this.bindOpenModal();
    this.bindEntryInputChange();
    this.bindSidebarInputChange();
    this.bindTermsCheckboxChange();
    this.bindInterceptSubmit();
    CartQuantitySelector.initAll();

    this.enableDisableSubmitButtons();
  }

  private bindInterceptSubmit(): void {
    this.submitForms.on('submit', (e) => {
      if (this.updateRowRequest) {
        e.preventDefault();
        e.stopPropagation();
        this.updateRowRequest.done(() => {
          $(e.target)
            .submit();
        });
      }
    });
  }

  private openSearchModal(data, triggerEl): void {
    const modalContent = this.generateModalContent();
    window.ACC.colorbox.open('', {
      html: modalContent(data),
      width: 800,
      onComplete: () => {
        const settings = {
          dom: '<"dataTable__controls"p>rt<"dataTable__controls"fp>',
          searching: false,
          info: false,
          pagingType: 'numbers',
          lengthMenu: [10],
          language: {
            lengthMenu: `${MessageHelper.getMessage('page.category.paginationSize.title')} _MENU_`,
            emptyTable: '',
          },
        };
        $(NewReturnsCartPage.modalTableSelector)
          .DataTable(settings);
        $.colorbox.resize();
        this.bindUpdateEntryButton(triggerEl);
      },
    });
  }

  private bindOpenModal(): void {
    this.openModalButton.on('click', (e): void => {
      const materialNumber = $(e.currentTarget)
        .data('material-number');
      const materialDescription = $(e.currentTarget)
        .data('material-description');
      const entryNumber = $(e.currentTarget)
        .data('entry-number');
      if (materialNumber) {
        PageHelper.showLoadingIndicator();
        NewReturnsCartPage.fetchSearchData(materialNumber)
          .done((response) => {
            this.openSearchModal(NewReturnsCartPage.handlebarsData(response, materialNumber, materialDescription, entryNumber), $(e.currentTarget));
          })
          .fail((error) => {
            console.error(error); // eslint-disable-line no-console
          })
          .always(() => {
            PageHelper.clearLoadingIndicator();
          });
      }

    });
  }

  private generateModalContent(): any {
    return Handlebars.compile(this.handlebarsTemplate.html());
  }

  static handlebarsData(unformattedData: any, materialNumber: string, materialDescription: string, entryNumber: string): any {
    const data = unformattedData;
    const entries: any[] = [];

    data.forEach((order) => {
      order.entries.forEach((entry) => {
        if (entry.materialNumber == materialNumber) {
          const formattedEntry = {
            salesDocumentId: order.orderId,
            id: entry.id,
            deliveryShippingDate: order.orderDate,
            orderQuantity: entry.orderQuantity,
          };
          entries.push(formattedEntry);
        }
      });
    });

    return {
      materialNumber,
      materialDescription,
      entryNumber,
      entries,
    };
  }

  private bindUpdateEntryButton(triggerEl: JQuery): void {
    $(NewReturnsCartPage.modalTableSelector)
      .on('click', NewReturnsCartPage.updateEntrySelector, (e) => {
        const referenceOrderNumber = $(e.currentTarget)
          .data('reference-order-number');
        const referencePositionNumber = $(e.currentTarget)
          .data('reference-position-number');
        const rowWrapper = triggerEl.closest('tr');
        const entryNumber = rowWrapper.data('entry-number') as string;

        rowWrapper.find('.js-originalOrderNumber')
          .val(referenceOrderNumber)
          .parsley()
          .validate();
        rowWrapper.find('.js-originalPosition')
          .val(referencePositionNumber)
          .parsley()
          .validate();

        this.updateEntry(NewReturnsCartPage.gatherEntryData(rowWrapper))
          .catch((error) => {
            const errorRow = $(`.js-errorRow[data-entry-number=${entryNumber}]`);
            errorRow
              .removeClass('d-none')
              .find('td')
              .html(error.responseText);
          })
          .then(() => {
            $.colorbox.close();
            this.enableDisableSubmitButtons();
          });
      });
  }

  private bindEntryInputChange(): void {
    const inputHandler = (e) => {
      const currentTarget = $(e.currentTarget);
      const rowWrapper = currentTarget.closest('tr');
      const entryNumber = rowWrapper.data('entry-number') as string;
      const entryData = NewReturnsCartPage.gatherEntryData(rowWrapper);

      if (currentTarget.hasClass('js-returnReason')) {
        const salesOrderText = $(`.js-notificationRow[data-entry-number=${entryNumber}]`).find('.js-salesOrderText');
        salesOrderText.prop('required', currentTarget.val() !== 'NO');
        salesOrderText.toggleClass('parsley-error', !salesOrderText.parsley()
          .isValid());
      }

      this.updateEntry(entryData)
        .fail((error) => {
          const errorRow = $(`.js-errorRow[data-entry-number=${entryNumber}]`);
          errorRow
            .removeClass('d-none')
            .html(error.responseText);
        });

      currentTarget.toggleClass('parsley-error', !currentTarget.parsley()
        .isValid());
      this.placeOrderCartButton.prop('disabled', !this.placeOrderIsValid());
      this.updateCartButton.prop('disabled', !this.updateCartIsValid());
    };
    this.entryInput.on('change', inputHandler);
  }

  static gatherEntryData(rowWrapper: JQuery): Record<string, unknown> {
    const entryNumber = rowWrapper.data('entry-number') as string;
    const entryRows = $(`tr[data-entry-number="${entryNumber}"]`);
    const returnReason = entryRows.find('.js-returnReason').val();
    const salesOrderText = entryRows.find('.js-salesOrderText').val();
    const referenceOrderNumber = entryRows.find('.js-originalOrderNumber').val();
    const referencePositionNumber = entryRows.find('.js-originalPosition').val();

    return {
      returnReason,
      salesOrderText,
      referenceOrderNumber,
      referencePositionNumber,
      entryNumber,
    };
  }

  private bindSidebarInputChange(): void {
    this.sidebarInput.on('change', () => {
      const orderRecipientId = this.sidebarOrderRecipientId.val();
      const orderNumber = this.sidebarOrderNumber.val();
      const data = {
        orderRecipientId,
        orderNumber,
      };

      NewReturnsCartPage.updateSidebar(data);
    });
  }

  private bindTermsCheckboxChange(): void {
    this.termsCheckboxes.on('input', () => {
      this.enableDisableSubmitButtons();
    });
  }

  private cartIsValid(): boolean {
    let valid = true;
    // eslint-disable-next-line consistent-return
    this.entryInput.each((index, el) => {
      if (!$(el)
        .parsley()
        .isValid()) {
        valid = false;
        return false;
      }
    });

    return valid;
  }

  private areTermsAccepted(): boolean {
    return this.termsCheckboxes.not(':checked').length === 0;
  }

  private placeOrderIsValid(): boolean {
    return this.placeOrderCartButton.data('allow-place-order') && this.cartIsValid() && this.areTermsAccepted();
  }

  private updateCartIsValid(): boolean {
    return this.updateCartButton.data('allow-update-cart') && this.cartIsValid();
  }

  private enableDisableSubmitButtons(): void {
    this.placeOrderCartButton.prop('disabled', !this.placeOrderIsValid());
    this.updateCartButton.prop('disabled', !this.updateCartIsValid());
  }

  static updateSidebar(data): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/newReturns/sidebar`,
      method: 'POST',
      data,
    });
  }

  private updateEntry(data): JQuery.jqXHR {
    PageHelper.showLoadingIndicator();
    this.updateRowRequest = $.ajax({
      url: `${window.ACC.config.encodedContextPath}/newReturns/updateNewCartEntries`,
      method: 'POST',
      data,
    })
      .always(() => {
        this.updateRowRequest = undefined;
        PageHelper.clearLoadingIndicator();
      });
    return this.updateRowRequest;
  }

  static fetchSearchData(id: string): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/webreturns/orders/search/materialnumber?code=${encodeURIComponent(id)}`,
      method: 'GET',
    });
  }

}
